import { useNavigate } from 'react-router-dom';

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                <i className="fas fa-map-signs" style={styles.icon}></i>
                <h1 style={styles.code}>404</h1>
                <p style={styles.title}>Página no encontrada</p>
                <p style={styles.subtitle}>La dirección que ingresaste no existe o no está disponible.</p>
                <button
                    className="btn btn-lg"
                    style={styles.btn}
                    onClick={() => navigate('/dashboard')}
                >
                    <i className="fas fa-home me-2"></i>
                    Ir al Dashboard
                </button>
            </div>
        </div>
    );
};

const styles = {
    page: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#111111',
        padding: '1.5rem',
    },
    card: {
        textAlign: 'center',
        maxWidth: '420px',
        width: '100%',
    },
    icon: {
        fontSize: '3rem',
        color: '#2E2E2E',
        marginBottom: '1rem',
    },
    code: {
        fontSize: '6rem',
        fontWeight: 900,
        color: '#F5C800',
        lineHeight: 1,
        margin: 0,
    },
    title: {
        fontSize: '1.4rem',
        fontWeight: 700,
        color: '#F0F0F0',
        margin: '0.75rem 0 0.5rem',
    },
    subtitle: {
        color: '#888888',
        fontSize: '0.95rem',
        marginBottom: '2rem',
    },
    btn: {
        background: '#F5C800',
        color: '#111111',
        border: 'none',
        borderRadius: '10px',
        padding: '0.85rem 2rem',
        fontWeight: 800,
        fontSize: '1rem',
    },
};

export default NotFound;
